import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=35f7705e&scoped=true"
import script from "./MsgDialog.vue?vue&type=script&lang=js"
export * from "./MsgDialog.vue?vue&type=script&lang=js"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&id=35f7705e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f7705e",
  null
  
)

export default component.exports